<template>
  <div
    class="col-start-1 col-span-12 row-start-1 row-span-6 z-0">
    <Map ref="MapPlotting" />
    <Sidebar>
      <SideHistoryKapal />
    </Sidebar>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Map from './Map.vue'
import Sidebar from './Sidebar'
import SideHistoryKapal from './SidebarPlottingKapal.vue'

export default {
  name: 'Plotting',
  components: {
    Map,
    Sidebar,
    SideHistoryKapal
  },
  computed: {
    ...mapGetters(['activeMenu'])
  },
  methods: {
    ...mapActions([
      'toInitPlotting',
      'toShowSidebar'
    ]),
    ...mapMutations([
      'setPlotting'
    ])
  },
  mounted: async function () {
    await this.$refs.MapPlotting.init()

    if (this.$route.query.transmitter) {
      this.setPlotting({
        transmitter: this.$route.query.transmitter
      })
    }

    this.toInitPlotting()
    this.toShowSidebar()
  }
}
</script>
